import type { AuthClient } from "@jetblue/kit-auth";
import { createAuthClient } from "@jetblue/kit-auth";
import { createOktaProvider } from "@jetblue/kit-auth-provider-okta";
import type { KitAuthConfig } from "../../types";

const createKitAuthClientSetup = () => {
  let cached: AuthClient | undefined;

  return (kitAuthConfig: KitAuthConfig) => {
    if (cached) {
      return cached;
    }
    const redirectUri = new URL(kitAuthConfig.REDIRECT_URI);
    const isOnCallbackUrl =
      "window" in globalThis &&
      globalThis.window.location.pathname === redirectUri.pathname;

    cached = createAuthClient({
      autoRestore: !isOnCallbackUrl,
      broadcastChannel: "dotcom-kit-auth",
      provider: createOktaProvider({
        clientId: kitAuthConfig.CLIENT_ID,
        issuer: kitAuthConfig.ISSUER,
        postLogoutRedirectUri: kitAuthConfig.POST_LOGOUT_REDIRECT_URI,
        redirectUri: kitAuthConfig.REDIRECT_URI,
        signInUrl: kitAuthConfig.SIGN_IN_URL,
        storage: kitAuthConfig.STORAGE,
      }),
    });
    return cached;
  };
};

export const kitAuthClientSetup = createKitAuthClientSetup();
